import './discover.scss';
import { DISCOVER_FULL } from 'domains/new-plan/constants/discover-full';
import { DISCOVER_FULL_HIGH } from 'domains/new-plan/constants/discover-full-high';
interface DiscoverProps {
  isLowerPrice: boolean;
  isTaxi: boolean;
}

const Discover: React.FC<DiscoverProps> = (props: DiscoverProps) => {
  const { isLowerPrice, isTaxi } = props;

  const DISCOVER = isLowerPrice ? DISCOVER_FULL : DISCOVER_FULL_HIGH;

  return (
    <div className="discover">
      <div className="discover__container">
        <h3 className="discover__container__title">
          {isTaxi ? (
            <b>Más que un seguro contra robo</b>
          ) : (
            <b>¡Auto Efectivo es más que un seguro contra robo!</b>
          )}
          <br />
          Descubre toda nuestra cobertura de asistencias y beneficios
        </h3>

        <div className="discover__container__cards">
          {DISCOVER.map((item) => {
            return (
              <div
                className="discover__container__cards__content"
                key={item.id}
              >
                <div className="discover__container__cards__content__card">
                  <img
                    src={item.img}
                    alt="accident"
                    className="discover__container__cards__content__card__image"
                  />
                  <div className="discover__container__cards__content__card__text">
                    <p className="discover__container__cards__content__card__text--title">
                      {item.title}
                    </p>
                    <p className="discover__container__cards__content__card__text--sub-title">
                      {item.subTitle}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Discover;

Discover.defaultProps = {
  isLowerPrice: false,
  isTaxi: false,
};
